
<div class="card">
    <div class="card-header">
      <h4 class="card-title float-left" id="basic-layout-form">{{'documentIntelligenceModels.title' | translate}}</h4>
      <div class="clear-float-left"></div>
      <br>

      <button [disabled]="!sectionPermission.CanAdd" class="btn btn-raised btn-primary float-right" (click)="addDocumentIntelligenceModel()">
        <i class="ft-plus-circle"></i> {{ hasDesktopView ? ('documentIntelligenceModels.addNewButtonText' | translate) : ('buttons.newText' | translate) }}
      </button>

      <app-company-selection-list [ngClass]="companySelectionListClass" [active]="hasSelectCompanyPermission" [hideLabel]="true" [selectCompanyText]="'users.selectCompanyPlaceHolder' | translate"
        (companyChangedEvent)="handleCompanyChanged($event)">
      </app-company-selection-list>

      <!-- <input type='text' class="d-none d-xl-block form-control filter-input" placeholder="{{'documentIntelligenceModels.filterByDescriptionPlaceHolder' | translate}}" (keyup)='searchFilter($event)' /> -->

    </div>
    <div class="card-body">
      <div [class]="hasDesktopView ? 'px-3' : 'px-0'">
        <table [class]="hasDesktopView ? 'table table-sortable table-responsive-md' : 'table-borderless table-sortable table-responsive-sm table'">
          <thead>
            <tr>
              <th *ngFor="let field of fieldCollection" [ngClass]="getTableHeaderClass(field.canSort, pageConfiguration.IsAscending, field.displayClass)"
                (click)="sort(field.canSort, field.name)">{{field.displayName | translate}}
              </th>
              <th>{{'documentIntelligenceModels.actionsFieldTitle' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let documentIntelligenceModel of collection | paginate: { id: 'server', itemsPerPage: pageConfiguration.PageSize, currentPage: pageConfiguration.PageNumber, totalItems: pageConfiguration.TotalRecords }">
              <td class="d-none d-sm-table-cell">{{documentIntelligenceModel.CompanyName}}</td>
              <td class="d-none d-lg-table-cell">{{documentIntelligenceModel.ModelId}}</td>
              <td class="d-none d-sm-table-cell">{{documentIntelligenceModel.Provider}}</td>
              <td class="d-none d-xl-table-cell">{{documentIntelligenceModel.ProviderModelId}}</td>
              <td class="d-none d-sm-table-cell">{{'documentIntelligenceModel.formatConverter_' + documentIntelligenceModel.DefaultFormatConverter | translate}}</td>
              <td>
                <a *ngIf="hasEditModelPermission" class="success" title="{{ 'documentIntelligenceModels.editModelTitle' | translate }}" (click)="editDocumentIntelligenceModel(documentIntelligenceModel)">
                  <i class="ft-edit-2 font-medium-3"></i>
                </a>
                <a *ngIf="hasEditModelPermission" class="danger" title="{{ 'documentIntelligenceModels.deleteModelTitle' | translate }}" (click)="deleteDocumentIntelligenceModel(documentIntelligenceModel)">
                  <i class="ft-trash-2 font-medium-3 ml-1"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        <pagination-controls *ngIf="pageConfiguration.TotalRecords > pageConfiguration.PageSize" (pageChange)="pageChanged($event)" id="server"
          previousLabel="{{'pagination.previousLabel' | translate}}" nextLabel="{{'pagination.nextLabel' | translate}}">
        </pagination-controls>
      </div>
    </div>
  </div>
